import React, { useState } from "react";
import { Text, Box, Button } from "components/ui";
import { useIsMobile } from "utils/hooks/useIsMobile";
import EquipmentFilter from "./EquipmentFilter";
import { ChevronDown } from "lucide-react-native";
import { useToken } from "@gluestack-style/react";

import { renderers } from "react-native-popup-menu";
import { useRouter } from "expo-router";
import PageHeader from "components/general/Headers/PageHeader";
type Props = {
	onSiteChange: (groupIdCollection: number[]) => void;
	onEquipmentTypeChange: (equipmentTypeIdCollection: number[]) => void;
	onIsHireChange: (isHire: boolean | undefined) => void;
};

const EquipmentHeader = ({ onSiteChange, onEquipmentTypeChange, onIsHireChange }: Props) => {
	const isMobile = useIsMobile();
	const resolvedPrimarylight = useToken("colors", "primarylight");
	const [newMachineButtonValue, setNewMachineButtonValue] = useState("New Machine");
	const [selectedEquipmentTypes, setSelectedEquipmentTypes] = useState<any[]>([]);

	const handleOnSiteChange = (site: any) => {
		onSiteChange([site.id]);
	};

	const { NotAnimatedContextMenu } = renderers;
	const handleOnEquipmentTypeChange = (equipmentTypes: any[]) => {
		// Update local state first
		setSelectedEquipmentTypes(equipmentTypes);
		// Then notify parent
		const selectedIds = equipmentTypes.map((equipmentType) => equipmentType.id);
		onEquipmentTypeChange(selectedIds);
	};

	const router = useRouter();
	const handleIsHireChange = (isHire: boolean | undefined) => {
		onIsHireChange(isHire);
	};

	const newMachineOptions = [
		{ value: "add", label: "Add machine" },
		{ value: "csv", label: "Upload .csv" },
	];
	const handleChange = (value: string) => {
		console.log("Selected:", value);
		// Add your logic here
	};
	return (
		<>
			<PageHeader title="My Equipment" />
			{isMobile && (
				<Box marginVertical={24} paddingHorizontal={12}>
					<Button bg="$basicwhite" borderWidth={1} borderColor="$primarylight" gap={8}>
						<Text color="$primarylight" fontWeight={"bold"}>
							Show Filters
						</Text>
						<ChevronDown color="#2B6FBB" />
					</Button>
				</Box>
			)}
			<Box paddingHorizontal={48}>{!isMobile && <EquipmentFilter onSiteChage={handleOnSiteChange} onEquipmentTypeChange={handleOnEquipmentTypeChange} onIsHireChange={handleIsHireChange} />}</Box>
		</>
	);
};

export default EquipmentHeader;
